import React, { useState, useEffect } from "react";

import MainGraph from "./MainGraph";

function Graph(props) {

  return (
    <div>
      <div className="Graph" style={{ opacity: "0.99" }}>
        <h4 style={{ zIndex: 100 }}>Live Orientation Graph</h4>
        <div style={{ maxWidth: "700px", margin: "0 auto" }}>
          <div className="agraph-outer-wrapper">
            <h6 style={{ opacity: "0.7" }}>Orientation(°)</h6>
            <div className="agraph-graph-container">
              <MainGraph graphdata={props.velocity} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Graph;
